import { ConditionalLink } from "components/conditionalLink";
import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { ArrowUpRight } from "components/icons/ArrowUpRight";
import { useAppDispatch } from "hooks/useAppDispatch";
import { useAppSelector } from "hooks/useAppSelector";
import { useAuth } from "hooks/useAuth";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { useCurrentEntity } from "hooks/useCurrentEntity";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useGetBookkeepingLogsQuery } from "store/apis/booksLockDate";
import { closeTransactionLockedModal } from "store/slices/transactions";

export const LockedFinancialEditBlocker = () => {
  const entity = useCurrentEntity();
  const entityId = useCurrentEntityId();
  const { uuid } = useAuth();
  const { isAdmin } = useRoleBasedView();
  const transactionLockedModal = useAppSelector(
    (state) => state.transactions.transactionLockedModal
  );

  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(closeTransactionLockedModal());
  };

  const { link } = useConstructInternalLink();

  const { data: lockLogs } = useGetBookkeepingLogsQuery(
    {
      entityId,
    },
    {
      skip: !entityId,
    }
  );

  const canUpdate = isAdmin || lockLogs?.logs?.[0]?.changed_by?.uuid === uuid;

  return (
    <Modal.Root open={transactionLockedModal} onOpenChange={onClose}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Locked Period - Action Restricted</Modal.Title>
          <Modal.Close onClick={onClose} />
        </Modal.Header>

        <Modal.Body className="t-text-body-sm t-text-text-60">
          <span className="t-font-bold">
            This action affects a locked financial period and is therefore
            restricted.
          </span>
          <br />
          {canUpdate ? (
            <span>
              This action affects a locked financial period and is therefore
              restricted.
              <br />
              <br />
              Do you want to continue?
            </span>
          ) : (
            <span>
              <br />
              Please reach out to your bookkeeper or Inkle Support for
              assistance.
            </span>
          )}
        </Modal.Body>
        <Modal.FooterButtonGroup>
          {canUpdate ? (
            <>
              <Button onClick={onClose}>Cancel</Button>

              <ConditionalLink
                onClick={onClose}
                to={link("/books/books-settings")}
              >
                <Button customType="primary">
                  <div className="t-flex t-gap-2 t-items-center">
                    <span>Go to settings</span>
                    <span>
                      <ArrowUpRight />
                    </span>
                  </div>
                </Button>
              </ConditionalLink>
            </>
          ) : (
            <>
              <ConditionalLink
                onClick={onClose}
                to={`/chat/${entity?.bookkeeping_channel}`}
              >
                <Button>Chat with us</Button>
              </ConditionalLink>

              <Button customType="primary" onClick={onClose}>
                Got it
              </Button>
            </>
          )}
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
